module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PG-1581bb4c678f532b9138ee110c304900.png";